import { styled } from "@mui/system";
import ButtonBase from '@mui/material/ButtonBase';

  // 各プルダウン項目押下時の波形アニメーションを無効化.
export const StyledMuiButtonBase= styled(ButtonBase, {
    shouldForwardProp: (prop) => prop !== 'disableRipple',
  })(({ theme }) => ({
    '&.MuiButtonBase-root': {
      '&.Mui-disabled': {
        pointerEvents: 'none',
      },
    },
  }));
  export const StyledMuiMenuItem= styled(ButtonBase, {
    shouldForwardProp: (prop) => prop !== 'disableRipple',
  })(({ theme }) => ({
    '&.MuiButtonBase-root': {
      '&.Mui-disabled': {
        pointerEvents: 'none',
      },
    },
  }));
export const StyledDataGrid = {
  height: "100%",
  width: "100%",
  fontSize: "0.875rem",
  lineHeight: "1",
  "& .rowcss": {
    fontSize: "16px",
    "&:hover": {
      bgcolor: "rgb(217, 245, 255)",
    },
  },
  "& ::-webkit-scrollbar-track": {
    backgroundColor: "white",
  },
  "& .MuiDataGrid-virtualScroller": {
    overflowX: "hidden",
  },
  "& .MuiDataGrid-iconButtonContainer": {
    marginLeft: "auto",
  },
  "& .MuiDataGrid-row:nth-child(even)": {
    backgroundColor: "#f7f7f9",
  },
  "& div div div div >.MuiDataGrid-cell": {
    borderBottom: "none",
  },
  "& .MuiDataGrid-row": {
    backgroundColor: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#E5F4F9",
    },
    "&:hover(none) ": {
      backgroundColor: "transparent",
    },
  },
  "& .MuiDataGrid-cell": {
    "&:focus": {
      outline: "none",
    },
    "&:focus-within": {
      outline: "none",
    },
  },
  "& .MuiDataGrid-cell--text": {
    width: "100%",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: "3",
    whiteSpace: "pre-line",
    wordWrap: "break-word",
    wordBreak: "break-all",
  },
  "& .MuiDataGrid-columnHeader": {
    backgroundColor: "#e6e6ea",
    borderRight: "1px solid #ccc",
    fontSize: "12px",
    height: "32px",
    "&:last-child": {
      border: "none",
    },
    "&:focus": {
      outline: "none",
    },
    "&:focus-within": {
      outline: "none",
    },
  },
  "& .MuiDataGrid-columnsContainer": {
    backgroundColor: "#E6E6EA",
    borderRight: "1px solid #ccc",
    fontSize: "12px",
  },
  "& .MuiDataGrid-columnSeparator": {
    opacity: "0",
  },

  "& .MuiButtonBase-root:hover": {
    backgroundColor: "transparent",
  },
}
export const StyledList = {
  width: '100%',
  maxWidth: 888,
  paddingTop: 0,
  paddingBottom: 0,
  fontSize: 16,
};
export const StyledListItem ={
  width: '100%',
  height: 40,
  backgroundColor: '#fff',
  borderBottom: '1px solid #e6e6ea',
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 8,
};
export const StyledIconButton = {
  width: 24,
  height: 24,
  marginRight: 24,
  marginTop: 8,
  marginBottom: 8
}